

import { Component, Vue, Watch, Prop } from "vue-property-decorator"
import api from "@/services/api"
import { namespace, Mutation } from "vuex-class"

const caseStore = namespace("cases")

@Component({
	components: {
	}
})
export default class CaseFileDisplay extends Vue {
	@Prop()
	file: any;

	@Prop({ type: Boolean, default: true })
	showDescription!: Boolean;

	@Prop({ type: Boolean, default: false })
	viewOnly!: Boolean

	@caseStore.Mutation
	public setPreviewFile!: (file: any) => void;

	private deleting = false;

	public get thumbnailStyle () {
		if (this.showPreview && this.hasThumbnail) {
			return {
				"background-image": "url(" + this.thumbnailPath + ")",
				"min-width": "60px",
				"min-height": "67px"
			}
		} else {
			return {}
		}
	}

	public downloadFile (file: any) {
		if (this.deleting) {
			return
		}

		if (this.showPreview) {
			this.setPreviewFile(file)
		} else {
			let downloadUrl = api.baseUrl + "files/download/" + file.id

			let link = document.createElement("a")
			link.href = downloadUrl
			link.download = downloadUrl
			link.click()
		}
	}

	private get showPreview (): boolean {
		const extension = this.extension(this.file.filename).toLowerCase()
		return (extension === "jpg" || extension === "png" || extension === "jpeg" || extension === "mp4" || extension === "mov")
	}

	private get hasThumbnail (): boolean {
		return this.file.thumbnailPath
	}

	private get thumbnailPath (): string {
		return api.baseUrl + "files/download/" + this.file.id + "?thumbnail=true"
	}

	private urlExists (extensionName: string) : boolean {
		var url = "/images/fileicons/" + extensionName + ".svg"

		var http = new XMLHttpRequest()
		http.open("HEAD", url, false)
		http.send()
		return http.status !== 404
	}

	private extension (filename: string): string {
		return filename.substring(filename.lastIndexOf(".") + 1)
	}

	private fileIconExtension (filename: string): string {
		var extensionName = this.extension(filename)

		if (this.urlExists(extensionName)) {
			return extensionName
		} else {
			return "default"
		}
	}

	private fileSize (fileSize: number) {
		if (fileSize < 1024) {
			return fileSize + "B"
		}

		fileSize = Math.round(fileSize / 1024)
		if (fileSize < 1024) {
			return fileSize + "KB"
		}

		fileSize = Math.round(fileSize / 1024)
		return fileSize + "MB"
	}

	public async removeFile () {
		this.$emit("removeFile")
	}
	//
	//
}
